import React, { useEffect, useRef, useState } from 'react';
import { sopFire } from '../../../utils/sopSwal';
import StageChrome from '../components/StageChrome';
import useGameTimer from '../components/useGameTimer';
import { ASSET, reportOnSubmit, stagecheck, submitStage } from '../../../utils/sopGame';
import '../stages.css';

const QUESTIONS = ['s5-1.png', 's5-2.png'];
const ANSWERS = ['sarfaroshi ki tamanna', 'vande mataram'];

export default function Stage5({ user, onComplete, reportId, initialSeconds }) {
  const [q, setQ] = useState(0);
  const [value, setValue] = useState('');
  const [status, setStatus] = useState('');
  const [score, setScore] = useState(0);
  const [collected, setCollected] = useState([]);
  const [sending, setSending] = useState(false);
  const scored = useRef({});
  const timeeRef = useRef('00:00:00');
  const { display } = useGameTimer(initialSeconds, (hms) => {
    timeeRef.current = hms;
  });

  useEffect(() => {
    stagecheck(user).then(setScore).catch(console.error);
  }, [user]);

  const onInput = (val) => {
    setValue(val);
    if (!val.trim()) {
      setStatus('');
      return;
    }
    const ok = val.trim().toLowerCase() === ANSWERS[q];
    setStatus(ok ? 'correct' : 'wrong');
    if (ok && !scored.current[q]) {
      scored.current[q] = true;
      setScore((s) => s + 1);
    }
  };

  const finish = async (answers) => {
    let points1 = 0;
    answers.forEach((a, i) => {
      if (String(a).toLowerCase() === ANSWERS[i]) points1 += 1;
    });
    setSending(true);
    try {
      await submitStage(user, {
        points: score,
        points1,
        round: 5,
        timee: timeeRef.current,
        reportId,
      });
      await reportOnSubmit(user, { points: score, timee: timeeRef.current, round: 5, reportId });
      await sopFire({
        text: 'Super work here. Proceed to identify a fact you may not have known!',
      });
      onComplete();
    } catch (err) {
      console.error(err);
      sopFire({ text: err.message || 'Submit failed' });
      setSending(false);
    }
  };

  const next = async () => {
    if (!value.trim()) {
      sopFire({ text: 'Please provide your response in the designated text box' });
      return;
    }
    const saved = value.trim().toLowerCase();
    if (saved !== ANSWERS[q]) {
      await sopFire({ text: `Correct Answer is ${ANSWERS[q].toUpperCase()}` });
    }
    setCollected((c) => [...c, saved]);
    setQ(1);
    setValue('');
    setStatus('');
  };

  const submit = async () => {
    if (sending) return;
    if (!value.trim()) {
      sopFire({ text: 'Please provide your response in the designated text box' });
      return;
    }
    const saved = value.trim().toLowerCase();
    if (saved !== ANSWERS[q]) {
      await sopFire({ text: `Correct Answer is ${ANSWERS[q].toUpperCase()}` });
    }
    await finish([...collected, saved]);
  };

  return (
    <StageChrome
      title="Decode the melodies from famous Indian freedom songs through the key words inscribed in this page"
      score={score}
      timerDisplay={display}
    >
      <div className="sop-quiz-wrap">
        <img className="sop-quiz-image" src={ASSET.img(QUESTIONS[q])} alt="" />
        <input
          className={`sop-input ${status}`}
          value={value}
          placeholder="Type Here"
          readOnly={status === 'correct'}
          onChange={(e) => onInput(e.target.value)}
          autoComplete="off"
        />
      </div>
      <div className="sop-actions">
        {q === 0 ? (
          <button type="button" className="sop-img-btn" onClick={next}>
            <img src={ASSET.img('next.png')} alt="Next" />
          </button>
        ) : (
          <button type="button" className="sop-img-btn" disabled={sending} onClick={submit}>
            <img src={ASSET.img('submit.png')} alt="Submit" />
          </button>
        )}
      </div>
    </StageChrome>
  );
}
